export default __webpack_public_path__ + "static/media/kitchen5-afterE-480w.20727322.webp";